import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { datumPassAPI } from '../../../services/api';
import { getApiErrorMessage } from '../../../shared/utils/apiError';
import i18n from '../../../i18n';

export const fetchDatumPassProduct = createAsyncThunk(
  'datumPass/fetchProduct',
  async (_, { rejectWithValue }) => {
    try {
      return await datumPassAPI.getProduct();
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error));
    }
  }
);

export const fetchDatumPassStatus = createAsyncThunk(
  'datumPass/fetchStatus',
  async (_, { rejectWithValue }) => {
    try {
      return await datumPassAPI.getStatus();
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error));
    }
  }
);

/** Direct purchase with coins (server-side debit). TON/Stars use PurchaseActions → provider flow. */
export const purchaseDatumPassWithCoins = createAsyncThunk(
  'datumPass/purchaseWithCoins',
  async (payload, { rejectWithValue }) => {
    try {
      return await datumPassAPI.purchaseWithCoins(payload);
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error));
    }
  }
);

const initialState = {
  product: null,
  isEnabled: false,
  expiresAt: null,
  productId: null,
  isLoading: false,
  error: null,
};

const datumPassSlice = createSlice({
  name: 'datumPass',
  initialState,
  reducers: {
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDatumPassProduct.fulfilled, (state, action) => {
        state.product = action.payload;
      })
      .addCase(fetchDatumPassStatus.fulfilled, (state, action) => {
        state.isEnabled = action.payload.datumPassEnabled;
        state.expiresAt = action.payload.expiresAt;
        state.productId = action.payload.productId;
      })
      .addCase(purchaseDatumPassWithCoins.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(purchaseDatumPassWithCoins.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isEnabled = action.payload.datumPassEnabled;
        state.expiresAt = action.payload.expiresAt;
      })
      .addCase(purchaseDatumPassWithCoins.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t('datumpass.purchase_failed', 'Purchase failed');
      });
  },
});

export const { clearError } = datumPassSlice.actions;
export default datumPassSlice.reducer;
